<script>
  import config from "./config/config";
  export let sponsorship_module;
  export let custom_header;
  export let checkLoader;
  export let headerText;
  export let logo_hyperlink_toggle;
  export let logo_hyperlink;
  const img_path = config.api_base_url + "/public/";
</script>

{#if checkLoader}
  {#if custom_header.custom_header}
    <div
      class="top-head-outline"
      style="border-bottom: {`${custom_header.border_bottom}`};background:{`${custom_header.background_color}`};"
    >
      <div class="top-head" style="height:60px;">
        <div
          class="top-brand-name"
          style="{`${custom_header.header_text_style}`}"
        >
          <a
            href="{logo_hyperlink_toggle
              ? logo_hyperlink
              : 'javascript:void(0)'}"
            style="color: inherit;text-decoration:none;"
          >
            <img
              src="{`${img_path}${custom_header.logo_image}`}"
              style="height:{`${custom_header.logo_image_height}`}; max-height:40px; "
              alt=""
            />
            {#if custom_header.header_text}
              {custom_header.header_text}
            {/if}
          </a>
        </div>
      </div>
    </div>
  {:else}
    <div class="top-head-outline">
      <div class="top-head">
        <a
          href="{logo_hyperlink_toggle ? logo_hyperlink : 'javascript:void(0)'}"
          style="color: inherit;text-decoration:none;"
        >
          <div class="top-brand-name">
            <img src="{`/logo.png`}" alt="" /> News Crossword
            <span class="top-client-name">
              {#if headerText}
                {headerText}
              {/if}
            </span>
          </div>
        </a>
      </div>
    </div>
  {/if}
{/if}

{#if sponsorship_module.sponsorship_module}
  <div class="sponsorship-module" style="border-top:none">
    <div class="sponsorship-module-inner mx-width">
      {#if sponsorship_module.hyperlink}
        <a
          href="{sponsorship_module.hyperlink}"
          target="_blank"
          rel="noopener noreferrer"
          class="hyperlink"
        >
          <span>
            <img
              src="{`${img_path}${sponsorship_module.sponsorship_logo}`}"
              alt=""
              style="height: {sponsorship_module.logo_height
                ? sponsorship_module.logo_height + 'px'
                : '40px'};"
            />
          </span>
          <span class="sponsorship-text">
            {sponsorship_module.sponsorship_text}
          </span>
        </a>
      {:else}
        <div class="hyperlink">
          <span>
            <img
              src="{`${img_path}${sponsorship_module.sponsorship_logo}`}"
              alt=""
              style="height: {sponsorship_module.logo_height
                ? sponsorship_module.logo_height + 'px'
                : '40px'};"
            />
          </span>
          <span class="sponsorship-text">
            {sponsorship_module.sponsorship_text}
          </span>
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  :global(.sponsorship-module) {
    border: 0.75px solid rgba(209, 209, 209, 1);
    background: linear-gradient(0deg, #f9f9f9 0%, #ffffff 100%);
  }

  :global(.mx-width) {
    max-width: 550px;
    margin: 0 auto;
  }

  :global(.sponsorship-module-logo) {
    height: 40px;
    width: 40px;
  }

  :global(.sponsorship-module-inner) {
    display: flex;
    align-items: center;
    padding: 4.5px 0px;
    justify-content: center;
  }

  :global(.sponsorship-text) {
    padding: 4px 8px;
    line-height: 1;
    font-size: clamp(12px, 3.5vw, 16.5px);
    font-weight: 400;
  }

  :global(.hyperlink) {
    text-decoration: none;
    color: #1a1a1a;
    display: flex;
    align-items: center;
    margin-top: 5px;
    margin-bottom: 5px;
    cursor: pointer;
  }
  .hyperlink:hover {
    color: #1a1a1a;
  }

  @media (max-width: 451px) {
    :global(.hyperlink) {
      margin-left: 7%;
      margin-right: 7%;
    }
  }

  @media (max-width: 356px) {
    :global(.hyperlink) {
      margin-left: 6%;
      margin-right: 6%;
    }
  }

  @media (max-width: 337px) {
    :global(.hyperlink) {
      margin-left: 5%;
      margin-right: 5%;
    }
  }

  @media (max-width: 330px) {
    :global(.hyperlink) {
      margin-left: 5%;
      margin-right: 4%;
    }
  }

  @media (max-width: 327px) {
    :global(.hyperlink) {
      margin-left: 4%;
      margin-right: 2%;
    }
  }

  :global(.top-head-outline) {
    position: relative;
    background: rgba(255, 255, 255, 1);
    border: 0.75px solid rgba(209, 209, 209, 1);
    z-index: 0;
  }

  :global(.top-head) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 18px;
  }

  @media (max-width: 460px) {
    :global(.top-head) {
      padding: 0px 10px;
    }
  }

  :global(.top-brand-name) {
    font-weight: 800;
    font-size: clamp(18px, 3.5vw, 23px);
    padding: 9px 0px;
    display: flex;
    align-items: center;
  }

  :global(.top-brand-name > img) {
    height: 40px;
    padding-right: 8px;
  }

  :global(.top-client-name) {
    font-size: clamp(17px, 3.5vw, 23px);
    font-weight: 400;
    padding-left: 4px;
  }
  :global(article.svelte-1sfnf1r) {
    all: unset;
  }
  :global(section#mobile.svelte-1sfnf1r) {
    all: unset;
  }
</style>
